import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ComponentesGlobalesModule } from 'app/componentes-globales/componentes-globales.module';
import { SharedModule } from 'app/shared/shared.module';
import { RepConcarComponent } from './rep-concar/rep-concar.component';

@NgModule({
  declarations: [
    RepConcarComponent
  ],
  imports: [
    CommonModule,
    SharedModule,
    ComponentesGlobalesModule,
  ],
  exports: [
    RepConcarComponent
  ]
})
export class RepFinanzasModule { }
